import React from 'react';

// Comdirect ist bisher die einzige Bank, die Wertpapierhandel unterstuetzt
// (siehe project_banking_module) - dieselbe Erkennung (fintsurl enthaelt
// "comdirect.de") wie schon beim Handeln-Icon in BankAccounts.js, hier als
// gemeinsamer Hook fuer Depotuebersicht und Orderbuch.
export default function useBrokerageConnections(x) {
	const [connections, setConnections] = React.useState(null);

	React.useEffect(() => {
		x.was.axPost('Backend/webapp.php?module=Banking&task=BankingConnectionList', {}, (result) => {
			if (result.data.returncode !== 1) {
				setConnections([]);
				return;
			}
			const all = result.data.content || [];
			setConnections(all.filter((c) => (c.fintsurl || '').indexOf('comdirect.de') !== -1));
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return connections;
}
